import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";
import Logo from "../../elements/logo/Logo";
import Nav from "./Nav";

function MobileMenu({ show, onClose }: any) {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".popup-mobile-menu .has-droupdown > a"
    );
    const elementsTwo = document.querySelectorAll(
      ".popup-mobile-menu .with-megamenu > a"
    );

    for (const i in elements) {
      if (elements.hasOwnProperty(i)) {
        (elements[i] as any).onclick = function () {
          this.parentElement
            .querySelector(".submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
    for (const prop in elementsTwo) {
      if (elementsTwo.hasOwnProperty(prop)) {
        (elementsTwo[prop] as any).onclick = function () {
          this.parentElement
            .querySelector(".rn-megamenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
  });

  return (
    <div className={`popup-mobile-menu ${show ? "active" : ""}`}>
      <div className="inner">
        <div className="header-top">
          <Logo />
          <div className="close-menu">
            <span className="close-button" onClick={onClose}>
              <FiX />
            </span>
          </div>
        </div>
        <Nav />
      </div>
    </div>
  );
}
export default MobileMenu;
